<div class="tw-w-full tw-h-full tw-min-h-[100vh] tw-bg-background">
  <div class="tw-w-full tw-h-full tw-min-h-[100vh] tw-flex tw-flex-col tw-justify-center tw-items-center">
    <div class="max-md:tw-flex-1 tw-min-w-full tw-max-w-full md:tw-min-w-[600px] md:tw-max-w-[600px] tw-h-fit tw-bg-secondary md:tw-rounded-[10px] tw-p-4">
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-3xl tw-text-white tw-text-center tw-mb-10">{{ "verify-account" | translate }}</p>
      <div class="tw-w-full tw-h-fit tw-px-8 md:tw-px-28">
        <p *ngIf="isError" class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-white tw-text-center tw-mb-6">
          {{ isErrorText | translate }}
        </p>
      </div>
    </div>
  </div>
</div>
